export default {
    path: '/order_resolutions',
    name: 'order_resolutions',
    component: () => import('../components/orderresolution/Layout'),
    redirect: '',
    meta: {
      breadcrumb: 'order.resolutions',
    },
    children: [
      {
        name: 'OrderResolutionList',
        path: '',
        component: () => import('../views/orderresolution/List'),
        meta: {
          breadcrumb: 'global.list',
        },
      },
      {
        name: 'OrderResolutionCreate',
        path: 'new',
        component: () => import('../views/orderresolution/Create'),
        meta: {
          breadcrumb: 'global.add',
        },
      },
      {
        name: 'OrderResolutionUpdate',
        path: ':id/edit',
        component: () => import('../views/orderresolution/Update'),
        meta: {
          breadcrumb: 'order.resolution',
        },
      },
      {
        name: 'OrderResolutionShow',
        path: ':id',
        component: () => import('../views/orderresolution/Show'),
        meta: {
          breadcrumb: 'order.resolution',
        },
      }
    ]
  };
  